module.exports = __webpack_public_path__ + "static/media/marche_posturale.c310327d.png";